"use client";

import { useEffect, useRef, useState } from "react";

import { CcCustomCalBooking } from "@/components/booking/CcCustomCalBooking";
import popupStyles from "@/data/booking-popup-styles.json";
import type { BookCallPopupVariant } from "@/lib/book-call-popup-copy";
import type { Lang } from "@/lib/types";

type CcCampaignBookingProps = {
  lang: Lang;
  bookingVariant: BookCallPopupVariant;
};

/**
 * The booking calendar embedded in the closing band, so a visitor who scrolled
 * all the way picks a time without opening another step. Same GHL calendar as
 * the popup; it mounts (and fetches slots) only near the viewport, and uses
 * the popup's stylesheet, which this page does not otherwise load up front.
 */
export function CcCampaignBooking({ lang, bookingVariant }: CcCampaignBookingProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [near, setNear] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node || near) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setNear(true);
      },
      { rootMargin: "800px 0px" },
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [near]);

  return (
    <div ref={ref} className="cc-campaign-final__widget" data-pending={near ? undefined : "true"}>
      {near ? (
        <>
          <link rel="stylesheet" href={popupStyles.href} precedence="booking-popup" />
          <CcCustomCalBooking
            lang={lang}
            bookingVariant={bookingVariant}
          />
        </>
      ) : null}
    </div>
  );
}
